import React, { useState, useContext } from 'react'
import { format } from 'date-fns'
import fr from 'date-fns/locale/fr'
import addDays from 'date-fns/addDays' 
import { AppContext } from '../../App'
 
const useHomeUsersPlanning = (valuesService) => {

    const _converteTimeToHours = (h) => {
        let hours = ''
        hours = h * 15
        var a = hours
        var b = 60 
        var quo = Math.floor(a/b) 
        let quoFinal = quo < 10 ? '0'+quo : quo
        var rem = a%b
        let remFinal = rem === 0 ? '00' : rem
        let final = quoFinal+':'+remFinal
        return final
    }
 
    const _displayHours = () => {
        const array = []
        for (let i = 0; i < 96; i++) {
            array.push(i)
        }
        return array
    }

    const _displayStaff = (day,date,services,staff,datesOff) => {
        const array = []
        // STAFF 
        staff.filter(valuesService.idStaff ? st => st.id === valuesService.idStaff : st => st).map(st => (

            // SERVICES
            services.filter(ser => ser.id === valuesService.idService && ser[st.id] === true).map(ser => (

                // LE JOUR EST-IL OUVERT 
                st[day+'open'] === true && [st[day+'amOpen'] === true || st[day+'pmOpen'] === true] &&

                // EST-CE UN JOUR DE VACANCES
                datesOff.filter(d => d.idStaff === st.id && date >= d.startDate && date <= d.endDate ).length === 0 &&

                array.push({
                    idStaff:st.id,
                    surnameStaff:st.surnameStaff,
                    nameStaff:st.nameStaff,
                    idService:ser.id,
                    priceService:ser.priceService,
                    durationService:ser.durationService,
                    nameService:ser.nameService,
                    amStart:_converteTime(st[day+'amOpen'],st[day+'hoursAMStart'],st[day+'minutesAMStart']),
                    amEnd:_converteTime(st[day+'amOpen'],st[day+'hoursAMEnd'],st[day+'minutesAMEnd']),
                    pmStart:_converteTime(st[day+'pmOpen'],st[day+'hoursPMStart'],st[day+'minutesPMStart']),
                    pmEnd:_converteTime(st[day+'pmOpen'],st[day+'hoursPMEnd'],st[day+'minutesPMEnd']),
                })
            ))
        ))
        return array
    }

    // DISPLAY 60 DAYS
    const _display60Days = () => {
        const array = []
        const m = 0

        for (let i = 0; i < 60; i++) {

            const addDay = addDays(new Date(Date.now()), i) 
            const day = format(new Date(addDay), 'EEEE', {locale:fr})
            const date = format(new Date(addDay), 'MM/dd/yyyy')
            const dateShow = format(new Date(addDay), 'EEEE dd MMMM', {locale:fr})

            array.push({ date:date, day:day, dateShow:dateShow })
        }

        return array 
    }

    const _converteTime = (open, hours, minutes) => {
        let minutesInt = parseInt(minutes,10)
        let min = ''
        if (minutesInt < 15) min = 0
        if (minutesInt > 14 && minutesInt < 30) min = 15
        if (minutesInt > 29 && minutesInt < 45) min = 30
        if (minutesInt > 44) min = 45
        let sum = ''
        if (open === true) {
            return sum = ((parseInt(hours,10)*60)+(min))/15
        } else { return null}
    }

    return { _converteTimeToHours, _displayHours, _displayStaff, _display60Days }
}

export default useHomeUsersPlanning
